module.exports = __webpack_public_path__ + "img/IMG_1634.17ca8068.jpg";